import React, { useContext, useEffect } from 'react'

import Typography from '@/components/shared/ui/Typography/Typography'
import HNContext from '@/context/HNContext'

export default function RedirectingPage() {
  const { userProfile } = useContext(HNContext)

  useEffect(() => {
    setTimeout(() => {
      const baseDomain = new URL(window.location.href)
      const domain = baseDomain.hostname
      window.location.href = `https://${domain}`
    }, 5000)
  }, [])

  return (
    <div className='flex h-screen items-center justify-center'>
      <div className='font-bold text-gray12  md:px-6'>Signing in</div>
      <div className='border-gray4 text-gray8  md:border-l-2 md:pl-6'>
        <Typography.Title level={5}>
          Redirecting to homepage...
        </Typography.Title>
        {userProfile && (
          <>
            <Typography.Text className='font-medium'>
              Signin with{' '}
            </Typography.Text>
            <Typography.Text className='font-medium !text-gray10 '>
              {userProfile?.email}
            </Typography.Text>
          </>
        )}
      </div>
    </div>
  )
}
